"use client"

import classNames from "classnames"
import React, { useEffect, useState } from "react"
import { Pagination } from "antd"

import Style from "./index.module.scss"

type Props = {
	total: number
	currentPage: number
	pageSize: number
	onChange: (page: number, pageSize: number) => void
	showTotal?: boolean
	showSizeChanger?: boolean
	hideOnSinglePage?: boolean
}

const ReportPagination: React.FC<Props> = ({
	total,
	currentPage,
	pageSize,
	onChange,
	showTotal = false,
	showSizeChanger = false,
	hideOnSinglePage = true,
}) => {
	const [isMobile, setIsMobile] = useState(false)

	useEffect(() => {
		const checkIsMobile = () => {
			if (typeof window !== "undefined") {
				setIsMobile(window.innerWidth < 768)
			}
		}

		checkIsMobile()
		window.addEventListener("resize", checkIsMobile)
		return () => {
			window.removeEventListener("resize", checkIsMobile)
		}
	}, [])

	if (!total) return null

	const totalInfo = showTotal ? (
		<span className={Style.total}>
			Total:&nbsp;
			<span>{total}</span>
		</span>
	) : (
		<span></span>
	)

	return (
		<section className={classNames(Style.container, { [Style.spaceContainer]: showTotal })}>
			{totalInfo}
			<Pagination
				simple={isMobile}
				current={currentPage}
				total={total}
				pageSize={pageSize}
				showSizeChanger={showSizeChanger}
				hideOnSinglePage={hideOnSinglePage}
				onChange={(page, size) => onChange(page, size)}
			/>
		</section>
	)
}

export default ReportPagination
